import * as React from 'react';
import { isBrowser } from 'react-device-detect';
// import dinein_r from '../../../assets/images/dinein_r.svg';
// import dinein_w from '../../../assets/images/dinein_w.svg';
// import togo_r from '../../../assets/images/togo_r.svg';
// import togo_w from '../../../assets/images/togo_w.svg';
// import dining_bg from '../../../assets/images/dining_bg.png';
// import close_bg from '../../../assets/images/close_bg.svg';
// import close_s from '../../../assets/images/close_s.svg';
// import close_w from '../../../assets/images/close_w.svg';
// import back_r from '../../../assets/images/back_r.svg';
import { Box, Dialog, Stack, Typography } from '@mui/material';
import { useKioskStore } from '../../../store/kiosk';
import { NavigateFunction, useNavigate } from "react-router-dom";
import { useState } from 'react';

export default function DiningOptions() {
	const navigate: NavigateFunction = useNavigate();
	const { kioskOrderList, setKioskOrderList, openDiningOption, setOpenDiningOption, setOpenCallName } = useKioskStore()
	const [mode, setMode] = useState(0)

	const handleSelectOption = (mode: number) => {
		// if (!isBrowser) {
		// 	if (window.ReactNativeWebView !== undefined) {
		// 		window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
		// 	} else if(window.Android !== undefined){
		// 		window.Android.postMessage(JSON.stringify({'type':'play'}));
		// 	}
		// }
		setMode(mode)
		setKioskOrderList({...kioskOrderList, 'orderType': mode})
		setOpenDiningOption(false)
		setOpenCallName(true)
		navigate('/callname')
	}

	const onClickBack = () => {
		// if (!isBrowser) {
		// 	if (window.ReactNativeWebView !== undefined) {
		// 		window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
		// 	} else if(window.Android !== undefined){
		// 		window.Android.postMessage(JSON.stringify({'type':'play'}));
		// 	}
		// }
		setOpenDiningOption(false)
		navigate('/main')
	}
	const hideDialog = () => {
		// if (!isBrowser) {
		// 	if (window.ReactNativeWebView !== undefined) {
		// 		window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
		// 	} else if(window.Android !== undefined){
		// 		window.Android.postMessage(JSON.stringify({'type':'play'}));
		// 	}
		// }
		setOpenDiningOption(false)
		navigate('/main')
	}
  return (
    <Dialog open={openDiningOption} fullScreen>
        <section style={{  
            backgroundImage: `url(${process.env.PUBLIC_URL+'/assets/images/dining_bg.png'})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
						height: '100vh',
    				width: '100vw',
						padding: '92px 240px 169px 240px'
        }}>
					<div className="touch-area" style={{position: 'absolute', left: '48px', top: '30px'}} onClick={()=> onClickBack()}>
						<Box>
							<img src={process.env.PUBLIC_URL+'/assets/images/close_s.svg'} width={'56px'} height={'56px'} alt="back" />
							<img src={process.env.PUBLIC_URL+'/assets/images/back_r.svg'} width={'30px'} height={'30px'} alt="back" style={{position: 'absolute', left: '13px', top: '13px'}}/>
						</Box>
					</div>
					<div className="touch-area" style={{position: 'absolute', right: '52px', top: '30px'}} onClick={()=> hideDialog()}>
						<Box>
							<img src={process.env.PUBLIC_URL+'/assets/images/close_bg.svg'} width={'56px'} height={'56px'} alt="back" />
							<img src={process.env.PUBLIC_URL+'/assets/images/close_w.svg'} width={'24px'} height={'24px'} alt="back" style={{position: 'absolute', left: '16px', top: '16px'}}/>
						</Box>
					</div>
					<Stack sx={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '109px'}}>
						<Typography sx={{color: '#000', fontSize: '60px', fontStyle: 'normal', fontWeight: '700'}}>WHERE WILL YOU ENJOY?</Typography>
						<Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: '100px'}}>
							<Stack sx={[{width: '340px', height: '340px', borderRadius: '340px', border: '3px solid #F72E13',  padding: '70px 100px', justifyContent: 'center' },
								mode === 1 ? {background: '#F72E13'} :{ background: '#fff'},
							]}
								onClick={() => handleSelectOption(1)}>
								<img src={mode === 1 ? process.env.PUBLIC_URL+'/assets/images/dinein_w.svg': process.env.PUBLIC_URL+'/assets/images/dinein_r.svg'} width={'140px'} height={'140px'} alt="dinein"/>
								<Typography sx={{color: mode !== 1 ?'#F72E13':'#fff' , fontSize: '40px', fontWeight: '600', fontStyle: 'normal', width: 'auto', minWidth: 'fit-content', height: '60px', textAlign: 'center', whiteSpace: 'nowrap'}}>Dine In</Typography>
							</Stack>
							<Stack sx={[{width: '340px', height: '340px', borderRadius: '340px', border: '3px solid #F72E13',  padding: '70px 100px', justifyContent: 'center' },
								mode === 2 ? {background: '#F72E13'} :{ background: '#fff'},
							]}
								onClick={() => handleSelectOption(2)}>
								<img src={mode === 2 ? process.env.PUBLIC_URL+'/assets/images/togo_w.svg': process.env.PUBLIC_URL+'/assets/images/togo_r.svg'} width={'140px'} height={'140px'} alt="togo"/>
								<Typography sx={{color: mode !== 2 ?'#F72E13': '#fff', fontSize: '40px', fontWeight: '600', fontStyle: 'normal',  width: 'auto', minWidth: 'fit-content', height: '60px', textAlign: 'center', whiteSpace: 'nowrap'}}>To GO</Typography>
							</Stack>
						</Box>
					</Stack>
        </section>
    </Dialog>
  );
}
